module.exports = __webpack_public_path__ + "img/p30_crystal.4fc26a9a.png";